/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type UnansweredCommentsTabContainerLocal = {
    readonly commentsOrderBy: COMMENT_SORT;
    readonly " $refType": "UnansweredCommentsTabContainerLocal";
};
export type UnansweredCommentsTabContainerLocal$data = UnansweredCommentsTabContainerLocal;
export type UnansweredCommentsTabContainerLocal$key = {
    readonly " $data"?: UnansweredCommentsTabContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnansweredCommentsTabContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '9fe30cc29c6e24488940fec445865f2c';
export default node;
